export type ListLoadFailureKind = 'forbidden' | 'failed';

/** A permission refusal offers nothing to retry; anything else offers to try again. */
export function ListLoadFailure({
  noun,
  failure,
  onRetry,
}: {
  noun: string;
  failure: ListLoadFailureKind;
  onRetry: () => void;
}) {
  const forbidden = failure === 'forbidden';
  return (
    <div
      role="alert"
      className="nb-card nb-card-tight"
      style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 16, margin: 14 }}
    >
      <span style={{ fontSize: 13, color: 'var(--nb-ink-2)' }}>
        {forbidden
          ? `You don’t have permission to view ${noun}.`
          : `The ${noun} couldn’t be loaded.`}
      </span>
      {!forbidden && (
        <button type="button" className="nb-btn" onClick={onRetry} style={{ marginLeft: 'auto' }}>
          Try again
        </button>
      )}
    </div>
  );
}
